{
  "actions": {
    "cancel": "Cancel",
    "confirm": "Confirm",
    "close": "Close"
  },
  "inputs": {
    "search_by_keyword": "Search..."
  },
  "standards": {
    "no_standard_data": "No standard data available",
    "custom_standard_info": "Custom standards have no predefined parameters: add the parameters and their alert levels in the form.",
    "no_parameters_available": "No parameters available for this standard and selected devices.",
    "tabs": {
      "overview": "Overview",
      "thresholds": "Thresholds"
    },
    "overview_statuses": "Each parameter is compared with this standard's ranges and gets one of these statuses:",
    "score_title": "Air quality score",
    "score_description": "Calculated for each timestamp (0–100) as a weighted average of the parameters below: a parameter counts 100 when good and falls to 0 at poor. Timestamps missing any of them have no score.",
    "no_score": "This standard has no air quality score; reports show the parameter statuses only.",
    "weight": "%{weight}% of the score"
  },
  "unsaved_changes": {
    "title": "Leave without saving?",
    "text": "Your changes on this page haven't been saved. If you leave, they'll be lost.",
    "stay": "Stay",
    "leave": "Leave"
  }
}
